"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 5.5a.5.5 0 0 1 .488.392c.158.711.516 1.78 1.061 2.656.56.9 1.222 1.452 1.951 1.452.829 0 1.589-.415 2.226-.995a6.3 6.3 0 0 0 1.327-1.729.5.5 0 0 1 .938.316l-1.347 7.184A1.5 1.5 0 0 1 17.17 16H6.83a1.5 1.5 0 0 1-1.474-1.224L4.009 7.592a.5.5 0 0 1 .938-.316 6.3 6.3 0 0 0 1.327 1.729C6.91 9.585 7.67 10 8.5 10c.73 0 1.39-.552 1.95-1.452.546-.877.904-1.945 1.062-2.656A.5.5 0 0 1 12 5.5M6.5 18a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"
}), 'CrownFilled');
